function TopicRelated(props) {
  return <div className="my-20 mx-auto">TODO</div>;
}

export default TopicRelated;
